import axiosInstance from "./api_helper";

const POS_BASE = "/api/pos";

const posService = {

  /* ================= CREATE ================= */
  create: (payload) => {
    return axiosInstance.post(POS_BASE, payload);
  },

  /* ================= UPDATE ================= */
  update: (id, payload) => {
    return axiosInstance.put(`${POS_BASE}/${id}`, payload);
  },

  /* ================= DELETE ================= */
  delete: (id) => {
    return axiosInstance.delete(`${POS_BASE}/${id}`);
  },

  /* ================= GET ALL ================= */
  getAll: () => {
    return axiosInstance.get(POS_BASE);
  },

  /* ================= GET ACTIVE ================= */
  getActive: () => {
    return axiosInstance.get(`${POS_BASE}/active`);
  },

  /* ================= SEARCH ================= */
  search: (query) => {
    return axiosInstance.get(`${POS_BASE}/search`, {
      params: { q: query }
    });
  },

  /* ================= FILTER ================= */
  filter: (filterDto) => {
    return axiosInstance.post(`${POS_BASE}/filter`, filterDto);
  }

};

export default posService;
